export default __webpack_public_path__ + "static/media/emptyCart.d669f13b.svg";